<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <process-workflow
        v-model="repair"
        :tabs="getTabs"
        :status="getRepairStatus"
        :role="getRole"/>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ProcessWorkflow from '@/components/common/process-tabs/ProcessWorkflow'
import { fetchRepair, updateRepairStatus } from '@/repositories/repairRepo'
import { execHttpRequestThrowable } from '@/services/http'
import { getObjectStatusByKey } from '@/utils/statusesUtil'
import tabs from '@/data/process/process-repair-tabs'
import { getUserRole } from '@/services/authService'

export default {
  provide() {
    return {
      tryToFetchData: async () => await this.tryToFetchRepair(),
      updateEntityStatus: async (id, status) => await updateRepairStatus(id, status) 
    }
  },
  components: {
    ProcessWorkflow
  },
  data() {
    return {
      repair: null,
      isDataFetched: false,
      repairStatusTokenNotifier: null
    }
  },
  methods: {
    async tryToFetchRepair() {
      this.isDataFetched = false
      const r = await execHttpRequestThrowable(async () => await fetchRepair(this.$route.params.id))
      this.repair = r.response.data
      this.repair.status = getObjectStatusByKey(this.repair.status)
      this.isDataFetched = true
    }
  },
  computed: {
    getTabs() {
      return tabs
    },
    getRepairStatus() {
      return this.isDataFetched ? this.repair.status : getObjectStatusByKey('NONE')
    },
    getRole() {
      return getUserRole()
    }
  },
  async mounted() {
    await this.tryToFetchRepair()
  },
  created() {
    this.$feedback.fill("Process Repair Page", this.$route.path)
  }
}
</script>
<style>

</style>